import { create } from 'zustand';

/**
 * "Where should this agent work?" — asked when an agent opens in a NEW TAB,
 * its profile folder is `inherit` and no Terminal default folder is set.
 * Without it the agent starts in the home folder and, on macOS, walks into
 * Desktop / Documents / Downloads, which pops one privacy prompt per folder.
 *
 * `launchProfile` awaits `askAgentCwd`; AgentCwdModal (mounted in
 * TerminalExtView) shows the pending request and settles it with
 * `answerAgentCwd` (a path, or null = cancelled → nothing launches).
 * The "+" menu's folder button asks for ANY agent, default folder or not
 * (`launchProfile(…, { pickCwd: true })`); `hasDefault` then keeps the modal
 * from overwriting the saved default unless the user ticks it.
 */
export const useAgentCwdPrompt = create(() => ({ request: null }));

export function askAgentCwd({ profileName, suggested, hasDefault = false } = {}) {
  return new Promise((resolve) => {
    // A second launch while one is open replaces it; the first is cancelled.
    useAgentCwdPrompt.getState().request?.resolve(null);
    useAgentCwdPrompt.setState({ request: { profileName: profileName || '', suggested: suggested || '', hasDefault, resolve } });
  });
}

export function answerAgentCwd(path) {
  const req = useAgentCwdPrompt.getState().request;
  useAgentCwdPrompt.setState({ request: null });
  req?.resolve(path || null);
}

/** The prompt applies to new-tab launches of `inherit` profiles with no root folder. */
export function needsAgentCwd(profile, where, defaultCwd) {
  return where === 'tab' && !defaultCwd && (profile.cwd?.mode || 'inherit') === 'inherit';
}
